<template>
    <div class="h-100">
        <d-contract-history
            v-model  = "history.show"
            :unit    = "history.unit"
            :history = "history.data"
            :contract= "contract"
        />

        <v-form class="h-100" ref="form">

            <c-flip-card
                v-model = "flipped"
                :top    = "8"
                :right  = "10"
                color   = "white--text"
                class   = "h-100"
            >
                <template v-slot:front>
                    <div class="w-100 h-100">
                        <c-column-header
                            :label = "title"
                            class  = "primary mb-1 w-100"
                        >
                            <template v-slot:filter>
                                <div
                                    v-if="edit && contract && contract.id"
                                    class="v-flex"
                                    style="margin-right: 30px; margin-top: -2px"
                                >
                                    <c-toolbar-button
                                        v-if     = "!readonly"
                                        class    = "mr-1"
                                        color    = "white"
                                        icon     = "mdi-content-save"
                                        size     = "20"
                                        :tooltip = "$t('contract.edit.store')"
                                        @click   = "onStore"
                                    />
                                    <c-toolbar-button
                                        class    = "mr-1"
                                        color    = "white"
                                        :icon    = "readonly ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                                        size     = "20"
                                        :tooltip = "readonly ? $t('contract.edit.off') : $t('contract.edit.on')"
                                        @click   = "onEdit"
                                    />
                                    <c-toolbar-button
                                        class    = "mr-1"
                                        v-if    = "contract"
                                        size    = "20"
                                        color   = "white"
                                        icon    = "mdi-history"
                                        tooltip = "Historie zum Vertrag"
                                        @click  = "onContractHistory"
                                    />
                               </div>
                            </template>
                        </c-column-header>

                        <div class="lm-border pa-3 contract-content">
                            <p-site-contract-header
                                v-if="contract && contract.id"
                                :contract = "contract"
                                :readonly = "readonly"
                            />

                            <slot name="front" />
                        </div>
                    </div>
                </template>
                <template v-slot:back>
                    <div class="w-100 h-100">
                        <c-column-header
                            :label = "title"
                            class  = "primary mb-1 w-100"
                        />

                        <div class="lm-border pa-3 contract-content">
                            <p-site-contract-header
                                v-if      = "contract && contract.id"
                                :contract = "contract"
                                :readonly = "readonly"
                            />

                            <p-site-contract-payment
                                v-if        = "contract && contract.id"
                                :contract   = "contract"
                                class       = "mt-1"
                                style = "height: 194px"
                            />

                            <p-site-contract-toc
                                v-if      = "contract && contract.id"
                                :contract = "contract"
                                class     = "mt-1"
                            />
                        </div>
                    </div>
                </template>
            </c-flip-card>
        </v-form>
    </div>
</template>

<script>

import CFlipCard            from "@/modules/core/components/utils/CFlipCard.vue";
import CColumnHeader        from "@/modules/core/components/utils/CColumnHeader.vue";
import CToolbarButton       from "@/modules/core/components/utils/CToolbarButton.vue";
import PSiteContractHeader  from "@/modules/msd/company/contract/components/controls/common/PSiteContractHeader.vue";
import PSiteContractPayment from "@/modules/msd/company/contract/components/controls/common/PSiteContractPayment.vue";
import PSiteContractToc     from "@/modules/msd/company/contract/components/controls/common/PSiteContractToc.vue";
import Contract from "@/modules/msd/company/contract/service/Contract";
import DContractHistory from "@/modules/msd/company/contract/components/controls/DContractHistory.vue";

export default {
    name: "CSiteContractFlipCard",

    components: {
        DContractHistory,
        PSiteContractToc,
        PSiteContractPayment,
        PSiteContractHeader,
        CToolbarButton,
        CColumnHeader,
        CFlipCard,
    },

    props: {
        title: {
            required: true,
        },

        contract: {
            required: true,
            type    : Object
        },

        unit: {

        },

        edit: {
            required: false,
            type    : Boolean,
            default : () => {
                return false;
            }
        }
    },

    data: () => ({
        flipped: false,
        readonly : true,
        history: {
            unit: null,
            show: false,
            data: null,
        },
    }),

    computed: {
    },

    methods: {
        onEdit () {
            this.readonly = !this.readonly
            this.$emit("readonly", this.readonly)
        },

        onStore () {
            this.$refs.form.validate ();
            this.$emit("store");
            this.readonly = true;
        },

        onContractHistory () {
            Contract.unit.history(this.unit.id, this.contract.type.id).then(data => {
                console.log("history", data)
                this.history.unit = this.unit;
                this.history.data = data;
                this.history.show = true;
            });
        },

        getFilter (contract) {
            return {
                customer: null,
                contact : null,
                contract: contract ? contract.id : null,
                company : contract ? this.contract.company.id : null,
            };
        }
    }
}
</script>

<style scoped>

.money ::v-deep input{
    text-align: right;
}

div::-webkit-scrollbar {
    width: 8px !important;
}

div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.3)!important;
    border-radius: 5px;
}

div::-webkit-scrollbar-thumb {
    background: white;
}

div:hover::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 5px;
}

.contract-content {
    height: calc(100% - 35px);
}

</style>